import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/common/close.png'


const _withScopeId = n => (_pushScopeId("data-v-0c6ced70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "modal_layer"
}
const _hoisted_2 = { class: "modal_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "chk" }
const _hoisted_6 = ["disabled", "checked", "onUpdate:modelValue", "onChange"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = ["onUpdate:modelValue", "disabled", "onChange"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "이상", -1))
const _hoisted_10 = {
  key: 2,
  class: "email_modal"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "이름", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "작성자 이메일", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "email_error" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "받는사람 이메일", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "email_error" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "제목", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "상태", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "내용", -1))
const _hoisted_22 = {
  key: 3,
  class: "report_modal"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "상태", -1))
const _hoisted_24 = ["value"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "비고", -1))
const _hoisted_26 = {
  key: 4,
  class: "partner_warp"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "modal_btn_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal_bg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fnEvent(false)))
        }))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", {
              class: "close_btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fnEvent(false)))
            }, _hoisted_4)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["modal_content", _ctx.props.isBg ? 'bg' : ''])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.props.customClass?.wrap])
            }, [
              (_ctx.props.type === 'nation')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.props.list, (item, idx) => {
                    return (_openBlock(), _createElementBlock("label", _hoisted_5, [
                      _withDirectives(_createElementVNode("input", {
                        disabled: _ctx.author.clfCd !== 99,
                        type: "checkbox",
                        checked: item.state === 1,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.state.checkedList[idx]) = $event),
                        onChange: ($event: any) => (_ctx.toggleNation(idx, _ctx.state.checkedList[idx]))
                      }, null, 40, _hoisted_6), [
                        [_vModelCheckbox, _ctx.state.checkedList[idx]]
                      ]),
                      _hoisted_7,
                      _createElementVNode("p", null, _toDisplayString(item.name), 1)
                    ]))
                  }), 256))
                : (_ctx.props.type === 'monitoring')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.props.list, (item, idx) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createTextVNode(_toDisplayString(item.label) + " ", 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.datas.monitValue[idx]) = $event),
                          disabled: _ctx.author.clfCd !== 99,
                          onChange: ($event: any) => (_ctx.checkNumber(idx))
                        }, null, 40, _hoisted_8), [
                          [
                            _vModelText,
                            _ctx.datas.monitValue[idx],
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _createTextVNode(" % "),
                        _hoisted_9
                      ]))
                    }), 256))
                  : (_ctx.props.type === 'email')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", null, [
                          _hoisted_11,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "이름",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emailForm.name) = $event)),
                            disabled: ""
                          }, null, 512), [
                            [_vModelText, _ctx.emailForm.name]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_12,
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            placeholder: "보내는 사람 이메일",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailForm.email) = $event)),
                            onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkMailPattern(0))),
                            disabled: ""
                          }, null, 544), [
                            [_vModelText, _ctx.emailForm.email]
                          ])
                        ]),
                        (!_ctx.emailForm.isPattern[0])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.emailForm.patternErr), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          _hoisted_15,
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            placeholder: "받는사람 이메일",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.emailForm.toEmail) = $event)),
                            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkMailPattern(1)))
                          }, null, 544), [
                            [_vModelText, _ctx.emailForm.toEmail]
                          ])
                        ]),
                        (!_ctx.emailForm.isPattern[1])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.emailForm.patternErr), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          _hoisted_18,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "제목",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.emailForm.title) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.emailForm.title]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_19,
                          _createElementVNode("input", {
                            type: "text",
                            placeholder: "신고 상태",
                            value: _ctx.emailForm.state === 0 ? '신고 전' : _ctx.emailForm.state === 1 ? '신고완료' : '신고 실패',
                            disabled: ""
                          }, null, 8, _hoisted_20)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_21,
                          _withDirectives(_createElementVNode("textarea", {
                            placeholder: "신고 내용",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.emailForm.content) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.emailForm.content]
                          ])
                        ])
                      ]))
                    : (_ctx.props.type === 'report')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", null, [
                            _hoisted_23,
                            _createElementVNode("input", {
                              type: "text",
                              placeholder: "신고 상태",
                              value: _ctx.reportForm.state === 0 ? '신고 전' : _ctx.reportForm.state === 1 ? '신고 완료' : '신고 실패',
                              disabled: ""
                            }, null, 8, _hoisted_24)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_25,
                            _withDirectives(_createElementVNode("textarea", {
                              placeholder: "비고",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.reportForm.remarks) = $event)),
                              disabled: ""
                            }, null, 512), [
                              [_vModelText, _ctx.reportForm.remarks]
                            ])
                          ])
                        ]))
                      : (_ctx.props.type === 'partner')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("img", {
                              style: {"width":"50%"},
                              src: require('@/assets/seoulInstitute.png'),
                              alt: ""
                            }, null, 8, _hoisted_27),
                            _createElementVNode("img", {
                              style: {"width":"40%"},
                              src: require('@/assets/aroLogo.png'),
                              alt: ""
                            }, null, 8, _hoisted_28)
                          ]))
                        : _createCommentVNode("", true)
            ], 2)
          ], 2),
          _withDirectives(_createElementVNode("div", _hoisted_29, [
            (_ctx.yes)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["modal_btn", [_ctx.props.customClass?.button]]),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.fnEvent(true)))
                }, _toDisplayString(_ctx.yes), 3))
              : _createCommentVNode("", true),
            (_ctx.no)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "modal_btn",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.fnEvent(false)))
                }, _toDisplayString(_ctx.no), 1))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.props.useBtn && _ctx.props.type !== 'nation']
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}